<template>
    <v-container class="pagea">
    <div class="products">


    <v-dialog v-model="showCancelDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>
            Are you sure you want to cancel your subscription ?<br>
            As mentioned in the terms of use there are no refunds and your search number will be reset to 0.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cancelSubscription(subscription.subscriptionId)">Yes</v-btn>
          <v-btn color="red darken-1" text @click="showCancelDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        
    <v-row align="center" justify="center" class="subscription" v-if="subscription.subscriptionId == null">
        <v-card
            class="mx-auto"
            max-width="100%"
            width="900px"
            color="primary"
            title="No subscription"     
        ></v-card>
    </v-row>

      <v-row align="center" justify="center" class="subscription" v-else>
        
          <v-card
            class="mx-auto"
            max-width="100%"
            width="500px"
            color="primary"
            
          >
            <v-card-item>
              <div>
                <div class="text-overline mb-1">
                    {{subscription_details.name}}
                </div>
                <div class="text-caption">Description: {{subscription_details.description}} <br> Subscription End/Renewal: {{ subscription.end }}</div>
              </div>
            </v-card-item>

            <v-card-actions>
              <v-btn  @click="showCancelDialog = true">
                Unsubscribe (no refund)
              </v-btn>
            </v-card-actions>

          </v-card>
      </v-row>
    </div>
    </v-container>
    
  </template>
<style>
#products {
  margin-top: 20%;
}

@media only screen and (min-width: 600px) {
  #products {
    margin-top: 0%;
  }
}

.subscription{
    display: flex;
    align-items: center; 
    justify-content: center;
    height: 100vh;  
  }
</style>

<script>
import { mapGetters } from 'vuex';
export default {
    data(){
        return {
          isAuthentified: localStorage.getItem('Authorization') !== null,
          subscription : {},
          subscription_details: {},
          showCancelDialog: false,
        };
    },
    created() {
      this.getSubscription();
    }, 

    computed: {
      ...mapGetters(['backend']),
    }, 

    methods: {
      async getSubscription(){
        const token = localStorage.getItem("Authorization");
        const subscription = await this.$axios.get(`${this.backend}/api/user/subscription`, {headers: {"Authorization": token}})
        this.subscription = subscription.data
        if (this.subscription && this.subscription.priceId) {
            await this.getSubscriptionDetails(this.subscription.priceId);
        } else {
            console.error('Price ID not found');
        }
      },

      async getSubscriptionDetails(price_id){
        const token = localStorage.getItem("Authorization");
        const subscription_details = await this.$axios.get(`${this.backend}/api/product/` + price_id, {headers: {"Authorization": token}})
        this.subscription_details = subscription_details.data
      },

      
      async cancelSubscription(subscriptionId){
        const token = localStorage.getItem("Authorization");
        await this.$axios.post(`${this.backend}/api/payment/cancel-subscription`, {subscriptionId: subscriptionId}, {headers:{"Authorization": token},})
        let userdata2 = JSON.parse(localStorage.getItem('userdata'))
        userdata2.research = 0
        localStorage.setItem('userdata', JSON.stringify(userdata2))
        window.location.href = '/cancel-subscription';
      }
    },
}

</script>